import { Carousel } from 'react-responsive-carousel';
import * as Styles from './styles';
import { ICampaign } from './CampaignInterface';
import { useTheme } from '../theme/useTheme';
import { useAnalytics } from '../third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import { Button } from '../../components/Buttons/Button';
import { useTranslation } from "react-i18next";
import { getLocalizedValues } from "../../v2/utils/utils";
import userProfileStore from '../core/UserProfileStore';
import { useState, useEffect} from 'react';

export default function BannerItems({
  bannerItems,
  closetColor
}: {
  bannerItems: ICampaign[];
  closetColor: any;
}) {
  const { darkMode } = useTheme();
  const { locale } = userProfileStore();

  const [activeIndex, setActiveIndex] = useState(0);
  
    useEffect(() => {
      bannerItems.forEach((item:any, idx) => {
        item.index = idx;
      });
      setActiveIndex(0);
    }, [bannerItems]);
  
    useEffect(() => {
      if (activeIndex === bannerItems.length - 1) {
        const timer = setTimeout(() => {
          setActiveIndex(0);
        }, 150000);
  
        return () => clearTimeout(timer);
      }
    }, [activeIndex, bannerItems.length]);

  const getIndicatorStyles = () => {
    return {
      background: darkMode ? '#CCCCCC' : '#4D4D4D',
      borderRadius: '16px',
      cursor: 'pointer',
      display: 'inline-block',
      height: '12px',
      margin: '0 8px',
      width: '12px',
    };
  };
  /* i18n translation*/

  const { t:translate } = useTranslation()
  const BANNER_TRANSLATE_KEY = 'banner'

  const theme = useTheme();
  const swipeStartHandler = (item: any) => {
    const bgColor = bannerItems[item].id === 'salty' ? '#42B5E1' : theme.darkMode ? '#1A1A1A' : '#f2f2f2';
    closetColor(bgColor);
  }

  const { trackEvent } = useAnalytics();
  const handleLearnMore = (carouselItem: ICampaign) => {
    trackEvent(AMPLITUDE_EVENTS.CAMPAIGN_ACTIONS, {
      'Action': 'Learn More',
      'Carousel Item': carouselItem.name,
    });
    window.open(carouselItem.link, '_blank')
  };
  return (
    <div data-testid="carouselContainer">
      <Carousel
        autoPlay
        infiniteLoop
        interval={150000}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        onChange={swipeStartHandler}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
            return (
              <li
                aria-label={`Selected: ${label} ${index + 1}`}
                style={{
                  ...getIndicatorStyles(),
                  background: darkMode ? '#4D4D4D' : '#CCCCCC',
                }}
                title={`Selected: ${label} ${index + 1}`}
              />
            );
          }
          return (
            <li
              aria-label={`${label} ${index + 1}`}
              key={index}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              role="button"
              style={getIndicatorStyles()}
              tabIndex={0}
              title={`${label} ${index + 1}`}
              value={index}
            />
          );
        }}
      >
        { bannerItems.map((carouselCard:any) => {
                  const localizedName = getLocalizedValues(locale, carouselCard, "name").name;
                  const localizedDescription = getLocalizedValues(locale, carouselCard, "description").description;
                  const rawLinkText = getLocalizedValues(locale, carouselCard, "linkText").linkText;
                  const localizedLinkText = (typeof rawLinkText === "string") ? rawLinkText : "";
                    return (
                    <Styles.BannerCardContainer key={carouselCard.id}>
                      <Styles.BannerImage data-testid="banner-image"
                        id={carouselCard.id}
                        url={carouselCard.showLogo? darkMode ? carouselCard.darkLogo : carouselCard.logo : ''}
                      />
                      <Styles.BannerContent>
                        <Styles.BannerIntro>{localizedName}</Styles.BannerIntro>
                        <Styles.BannerDescription>
                          {localizedDescription}
                        </Styles.BannerDescription>
                        <Styles.BannerContentFooter>
                            {(carouselCard.link !== undefined && carouselCard.link.trim() !== "") &&
                              <Button style={{ marginRight: '29px' }} data-testid="learn-more-btn"
                                darkMode={darkMode}
                                onClick={() => handleLearnMore(carouselCard)}
                                rel="noreferrer"
                                target="_blank"
                                text={localizedLinkText !== undefined && (localizedLinkText).trim() !== ""
                                  && (localizedLinkText).trim().toLowerCase() !== "learn more" ? localizedLinkText : translate(`${BANNER_TRANSLATE_KEY}.learn_more`)}
                                tabIndex={carouselCard.index === activeIndex ? 0 : -1}
                              />
                            }
                        </Styles.BannerContentFooter>
                      </Styles.BannerContent>
                    </Styles.BannerCardContainer>
                  );
                }) }
      </Carousel>
    </div>
  );
}
